( function( global, $ ) {
    "use strict";

    $('body').on('app.ready', function(ev) {
        var $quickSearch = $('[data-quicksearch]'),
            $control = $quickSearch.find('[data-quicksearch-control]');

        if ($control.length === 0) {
            return console.warn('Quick search control element was not found.');
        }

        $control.easyAutocomplete({
            minCharNumber: 3,
            requestDelay: 250,
            getValue: "name",
            template: {
                type: "links",
                fields: {
                    link: "url"
                }
            },
            url: function(term) {
                return "/api/quick-search?query=" + encodeURIComponent(term);
            },
            ajaxSettings: {
                dataType: 'json',
                headers: {
                    'Authorization': 'Bearer ' + ev.app.options.apiToken
                }
            },
            list : {
                onKeyEnterEvent: function() {
                    window.location.assign(
                        $('[data-quicksearch] [data-quicksearch-control]').getSelectedItemData().url
                    );
                }
            }
        });
    });

}( window.groots, jQuery ));
